import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import { useParams } from "react-router-dom";
import MetaHead from "../../../Common/Metahead";
import EmailTemplatePreivew from "../../../Modals/email-template-preview";
import { campaignDetails } from "../../../../stores/actions/campaign.actions.types";
import { emailTemplateDetails } from "../../../../stores/actions/emailtemplate.actions.types";
import { imageBaseUrl } from "../../../../utilities/constants";

const CampaignDetails = ({ campaignDetails, emailTemplateDetails }) => {
  const { id } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [template, setTemplate] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [emailLoading, setEmailLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchData = useCallback(() => {
    if (!id) return;
    campaignDetails({
      id,
      callback: (res) => {
        if (res.success) {
          setCampaign(res.data.data?.campaign);
          setAnalytics(res.data.data?.analytics);
          setLoading(false);
        }
      },
    });
  }, [id, campaignDetails]);

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (campaign?.emailTemplateId) {
      setEmailLoading(true);
      emailTemplateDetails({
        id: campaign?.emailTemplateId,
        callback: (data) => {
          if (data?.success) {
            setEmailLoading(false);
            setTemplate(data?.data?.emailTemplate);
          }
        },
      });
    }
  }, [campaign?.emailTemplateId, modalOpen]);

  if (loading || !campaign) {
    return (
      <div className='flex items-center justify-center min-h-96'>
        <BiLoaderAlt className='animate-spin text-4xl text-primary' />
      </div>
    );
  }

  const deliveryRate =
    analytics?.delivered && analytics?.accepted
      ? ((analytics.delivered / analytics.accepted) * 100).toFixed(2)
      : 0;
  const failedRate =
    analytics?.failed && analytics?.accepted
      ? ((analytics.failed / analytics.accepted) * 100).toFixed(2)
      : 0;

  return (
    <div className='mx-auto p-6 bg-white dark:bg-boxdark dark:text-white rounded-lg shadow'>
      <MetaHead title={"Campaign Details"} />

      <div className='rounded-lg mb-6 bg-gray-50 dark:bg-gray-800 dark:border-gray-700'>
        {analytics && (
          <Section title='Analytics'>
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4'>
              <AnalyticsCard label='Email Sent' value={analytics.accepted} />
              <AnalyticsCard
                label='Delivered'
                value={analytics.delivered}
                // color='green'
              />
              <AnalyticsCard
                label='Failed'
                value={analytics.failed}
                // color='red'
              />
              {/* <AnalyticsCard
                label='Opened'
                value={analytics.opened}
                // color='purple'
              />
              <AnalyticsCard
                label='Clicked'
                value={analytics.clicked}
                // color='orange'
              /> */}
              <AnalyticsCard
                label='Unsubscribed'
                value={analytics.unsubscribed}
                // color='yellow'
              />
              {/* <AnalyticsCard
                label='Complained'
                value={analytics.complained}
                // color='pink'
              />
              <AnalyticsCard
                label='Dropped'
                value={analytics.dropped}
                // color='gray'
              /> */}
              <AnalyticsCard label='Delivery Rate (%)' value={deliveryRate} />
              <AnalyticsCard label='Failed Rate (%)' value={failedRate} />
            </div>
          </Section>
        )}
        <h2 className='text-xl px-5 font-semibold mb-4'>General Information</h2>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 p-5'>
          <Detail label='Name' value={campaign.name} />
          <Detail label='Type' value={campaign.type} />
          <Detail label='Status' value={campaign.status} />
          <Detail label='Target Audience' value={campaign.targetedAudience} />
          <Detail
            label='Created At'
            value={new Date(campaign.createdAt).toLocaleString()}
          />
          <Detail
            label='Updated At'
            value={new Date(campaign.updatedAt).toLocaleString()}
          />
          <Detail label='Sent Count' value={campaign.sentCount} />
          <Detail label='Failed Count' value={campaign.failedCount} />
        </div>
      </div>

      {campaign.description && (
        <Section title='Description'>
          <p>{campaign.description}</p>
        </Section>
      )}

      {campaign.smsText && (
        <Section title='SMS Content'>
          <img
            src={`${imageBaseUrl}/${campaign.mediaUrl}`}
            alt='Preview'
            className='w-32 h-32 mb-5'
          />
          <div className='p-3 rounded border bg-white dark:bg-gray-900 dark:border-gray-700'>
            {campaign.smsText}
          </div>
        </Section>
      )}

      {campaign.emailTemplateId && (
        <Section title='Email Template'>
          <p>
            <strong>Template ID:</strong> {campaign.emailTemplateId}
          </p>
          <button onClick={() => setModalOpen(true)}>
            {emailLoading ? "Preview Loading..." : "Show Email Preview"}
          </button>
        </Section>
      )}

      <EmailTemplatePreivew
        block={template}
        opened={modalOpen}
        setOpend={setModalOpen}
      />
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className='mb-6 p-5  rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700'>
    <h2 className='text-xl font-semibold mb-3'>{title}</h2>
    {children}
  </div>
);

const Detail = ({ label, value }) => (
  <p className='text-sm'>
    <strong className='font-semibold'>{label}:</strong> {value ?? "N/A"}
  </p>
);

const AnalyticsCard = ({ label, value, color }) => (
  <div
    className={`p-4 rounded-lg border  shadow  dark:text-white text-black bg-${color}-500 flex flex-col items-center justify-center`}
  >
    <p className='text-lg font-bold'>{value ?? 0}</p>
    <p className='text-sm'>{label}</p>
  </div>
);

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  campaignDetails,
  emailTemplateDetails,
})(CampaignDetails);
